import * as React from 'react';
import { View } from 'react-native';
import { useAnimatedProps } from 'react-native-reanimated';
import { rem } from 'design-system/values';
import { styles as textStyles } from 'design-system/Text';
import { AnimatedTextInput } from 'design-system/AnimatedComponents';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const CandleSize = ({ selectedInfoObj }) => {
    const styles = useStyles(styleSet);
    const animatedProps = useAnimatedProps(() => ({
        text: selectedInfoObj.value ? selectedInfoObj.value.formattedTimeStamp : '',
    }), [selectedInfoObj]);
    return (<View style={styles.container}>
      <AnimatedTextInput editable={false} defaultValue={''} numberOfLines={1} allowFontScaling={false} style={styles.timestampStyles} animatedProps={animatedProps}/>
    </View>);
};
export default React.memo(CandleSize);
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        paddingHorizontal: rem(16),
    },
    timestampStyles: {
        ...textStyles.TextThin_14,
        margin: 0,
        padding: 0,
        height: rem(21),
        color: colors.text.secondary,
    },
}));
